import { useState, useEffect } from 'react';
import { redirect } from 'react-router-dom';

const StatCard = ({ title, subtitle, value, color = 'blue', loading , isCurrency, RedirectToRevenue}) => {
  const [displayValue, setDisplayValue] = useState(0);

  const colorClasses = {
    blue: 'text-blue-600',
    purple: 'text-purple-600',
    pink: 'text-pink-600',
    green: 'text-green-600',
    orange: 'text-orange-600',
    red:'text-red-600',
    yellow:'text-slate-600'
  };

  const formatNumber = (num) => {
    if (!num) return "0";

    const number = Number(num);

    const format = (value, suffix) => {
      const formatted = value.toFixed(1);
      return formatted.endsWith(".0")
        ? formatted.slice(0, -2) + suffix
        : formatted + suffix;
    };

    if (number >= 1e12) return format(number / 1e12, "T");
    if (number >= 1e9) return format(number / 1e9, "B");
    if (number >= 1e6) return format(number / 1e6, "M");
    if (number >= 1e3) return format(number / 1e3, "K");

    return number.toString();
  };

  const formattedValue = formatNumber(value);
  const fullValue = Number(value).toLocaleString();

  // useEffect(() => {
  //   const numericValue = parseInt(value, 10);
  //   if (isNaN(numericValue)) { setDisplayValue(value); return; }
  //   const duration = 2000;
  //   const steps = 60;
  //   const stepDuration = duration / steps;
  //   const increment = numericValue / steps;
  //   let currentStep = 0;
  //   const timer = setInterval(() => {
  //     currentStep++;
  //     if (currentStep >= steps) { setDisplayValue(numericValue); clearInterval(timer); }
  //     else { setDisplayValue(Math.floor(increment * currentStep)); }
  //   }, stepDuration);
  //   return () => clearInterval(timer);
  // }, [value]);

  return (
    <div className={`bg-white rounded-lg p-4 shadow-[0px_0px_4px_#6d6d6d4a] ${RedirectToRevenue && 'cursor-pointer'} border border-gray-200`} onClick={RedirectToRevenue}>
      <div className="flex flex-col gap-2">
        <h3 className="font-medium text-black text-sm sm:text-sm md:text-sm lg:text-base tracking-[0] leading-[normal]">
          {title}
        </h3>
        <div className="flex justify-between items-start gap-2 min-w-0">
          <p className="font-normal text-[#4c4c4c] text-xs sm:text-xs md:text-sm tracking-[0] leading-[normal] break-words">
            {subtitle}
          </p>
          <div
            className={`font-bold text-[24px] sm:text-[26px] md:text-[28px] lg:text-[24px] xl:text-[30px] 2xl:text-[35px] tracking-[0] leading-[normal] text-right break-words flex-shrink-0 ${colorClasses[color]}`}
             title={isCurrency ? `$${fullValue}` : ""}
          >
            {loading ? (
              <span className="inline-block w-5 h-5 border-2 border-current border-t-transparent rounded-full animate-spin" />
            ) : (
              <>
                {isCurrency ? "$" : ""}
                {formattedValue}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatCard;